import { StackedBarGraphData, StackedBarGraph } from '../../Charts/StackedBarGraph/StackedBarGraph'

export function RenderTotalsAndChart(
    total: any,
    first: number,
    vs: number,
    totalText: string,
    firstText: string,
    vsText: string,
    colors: string[],
    showingTimeOfDay: boolean,
    data: StackedBarGraphData,
  ) {
    return (
      <div className="TotalsAndChart">
        <div className="totalsColumn">
          <div className="total">
            <div className="number">{total}</div>
            <label>{totalText}</label>
          </div>
  
          <div className="vs">
            <div className="number" style={{ color: colors[0] }}>
              {first.toLocaleString()}
            </div>
            <label>{firstText}</label>
            <div className="verseLabel">vs.</div>
            <div className="number" style={{ color: colors[1] }}>
              {vs.toLocaleString()}
            </div>
            <label>{vsText}</label>
          </div>
        </div>
        <div className="stackedChart">
          <StackedBarGraph data={data} width={470} height={260} showingTimeOfDay={showingTimeOfDay} />
        </div>
      </div>
    );
  }